import commands from './commands';
import queue from './queue';
import settings from './settings';
import del from './delete';
import get from './get';
import put from './put';

export default { commands, queue, settings, del, get, put };
